<template>
  <div class="w-100 d-flex align-items-center justify-content-between">
    <div
      class="w-100 w-md-25"
      style="font-size: var(--font-sm); color: #64646480; font-weight: 400"
    >
      Showing {{ (perPage * (currentPageNumber - 1)) + 1 }} - {{ Math.min(perPage * currentPageNumber, totalItems) }} of {{ totalItems }}
    </div>
    <div
      class="pagination-content w-100 d-flex align-items-center justify-content-end"
    >
      <button
        class="btn-style me-2 me-md-3"
        type="button"
        @click="onClickPreviousPage"
        :disabled="isInFirstPage"
        aria-label="Go to previous page"
        data-testid="previous-page-btn"
      >
        Previous
      </button>

      <span v-for="page in totalPages" :key="page">
        <button
          :class="['pagination-btn', currentPageNumber == page ? 'active' : '']"
          style="margin: 0 0.125rem"
          @click="() => goToPage(page)"
          type="button"
          :data-testid="`go-to-page-btn${page}`"
        >
          {{ page }}
        </button>
      </span>

      <button
        class="btn-style ms-2 ms-md-3"
        type="button"
        @click="onClickNextPage"
        :disabled="isInLastPage"
        aria-label="Go to next page"
        data-testid="next-page-btn"
      >
        Next
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";

const props = defineProps<{
  currentPageNumber: number;
  perPage: number;
  totalItems: number;
  maxVisibleButtons?: number;
}>();

const emit = defineEmits<(e: "pagechanged", page: number) => void>();

const totalPages = computed(() => Math.ceil(props.totalItems / props.perPage));
const isInFirstPage = computed(() => props.currentPageNumber === 1);
const isInLastPage = computed(() => props.currentPageNumber === totalPages.value);

const onClickPreviousPage = () => {
  if (isInFirstPage.value) return;
  emit("pagechanged", props.currentPageNumber - 1);
};

const goToPage = (page: number) => {
  if (page < 1 || page > totalPages.value) return;
  emit("pagechanged", page);
};

const onClickNextPage = () => {
  if (isInLastPage.value) return;
  emit("pagechanged", props.currentPageNumber + 1);
};  
</script>

<style scoped>
.pagination-btn {
  border-radius: 2px;
  color: #646464;
  width: 1.5rem;
  font-weight: 400;
}

.active {
  background: rgba(108, 189, 69, 0.15);
  cursor: not-allowed;
  font-weight: 600;
}

button:disabled {
  opacity: 0.5;
}

div .btn-style {
  font-weight: 500;
  color: #646464;
  display: flex;
  align-items: center;
}
</style>
